import React, { Fragment } from 'react';
import LoginForm from '../../components/LoginForm';

const Login = () => (
    <Fragment>
        <LoginForm />
    </Fragment>
)

export default Login;